import React from 'react';
import { Tooltip, Box } from '@mui/material';

export interface TireInfo {
  name: string;
  displayValue: string;
  unit: string;
}

interface TireTooltipProps {
  children: React.ReactNode;
  tireInfo?: TireInfo;
}

const TireTooltip: React.FC<TireTooltipProps> = ({ children, tireInfo }) => {
  if (!tireInfo) return <>{children}</>;

  return (
    <Tooltip
      title={
        <Box sx={{ p: 0.5 }}>
          <div
            style={{
              fontSize: '12px',
              color: 'white',
              fontWeight: '500',
              marginBottom: '4px',
            }}
          >
            {tireInfo.name}
          </div>
          <div style={{ fontSize: '11px', color: 'white', opacity: 0.9 }}>
            {tireInfo.displayValue === 'N/A' ||
            tireInfo.displayValue === null ||
            tireInfo.displayValue === undefined
              ? 'N/A'
              : `${Math.round(parseFloat(tireInfo.displayValue))} ${
                  tireInfo.unit
                }`}
          </div>
        </Box>
      }
      placement="top"
      arrow
    >
      <g style={{ cursor: 'pointer' }}>{children}</g>
    </Tooltip>
  );
};

export default TireTooltip;
